(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bv-annonce-defilante"] && !Shopify.designMode) return;
  try {
    
  /*
   * Durée = largeur d'un groupe / vitesse en px/s.
   * Ainsi la vitesse perçue reste la même quel que soit le nombre de messages
   * ou la largeur de l'écran — une durée fixe en réglage ferait l'inverse.
   *
   * En mode éditorial il n'y a pas de piste : regler() sort immédiatement.
   */
  (function () {
    function regler(bande) {
      var piste = bande.querySelector('.bvad__track');
      if (!piste) return;
      var groupe = piste.firstElementChild;
      if (!groupe) return;
      var largeur = groupe.getBoundingClientRect().width;
      var vitesse = parseFloat(bande.dataset.bvadSpeed) || 60;
      if (largeur > 0 && vitesse > 0) {
        piste.style.setProperty('--bvad-duration', (largeur / vitesse).toFixed(2) + 's');
      }
    }

    function toutRegler() {
      document.querySelectorAll('[data-bvad]').forEach(regler);
    }

    var enAttente = false;
    function auRedimensionnement() {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () {
        enAttente = false;
        toutRegler();
      });
    }

    function demarrer() {
      toutRegler();
      window.addEventListener('resize', auRedimensionnement);
      // Les polices arrivent après le premier rendu et changent la largeur mesurée.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(toutRegler);
      }
      document.addEventListener('shopify:section:load', toutRegler);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', demarrer);
    } else {
      demarrer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bv-journal"] && !Shopify.designMode) return;
  try {
    
  /* Botaverra - defilement de la section blog.

     Calque sur assets/botaverra-collection-bandes.js, avec la pause au survol
     en plus. Quatre garde-fous : hors ecran on ne tourne pas, le survol met en
     pause, le premier clic sur une puce arrete l'automatisme DEFINITIVEMENT,
     et `prefers-reduced-motion` coupe tout.

     Lecture de position plutot qu'IntersectionObserver : la page defile dans
     `.page-wrapper` et non dans la fenetre, l'observateur n'y est pas fiable
     (mesure du 2026-08-22, voir le script des bandes). */
  (function () {
    var REDUIT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function aLEcran(el) {
      var r = el.getBoundingClientRect();
      var haut = Math.max(r.top, 0);
      var bas = Math.min(r.bottom, window.innerHeight);
      return r.height > 0 && (bas - haut) / r.height > 0.33;
    }

    function init(bloc) {
      if (bloc.dataset.bvjPret === 'oui') return;
      bloc.dataset.bvjPret = 'oui';

      var scene = bloc.querySelector('.bvj__scene');
      if (!scene) return;

      var vues = [].slice.call(scene.querySelectorAll('.bvj__vue'));
      if (vues.length < 2) return;

      var delai = parseInt(bloc.getAttribute('data-bvj-auto'), 10) || 0;
      var index = 0;
      var minuteur = null;
      var rendu = false;
      var survol = false;

      var points = document.createElement('div');
      points.className = 'bvj__points';

      var boutons = vues.map(function (vue, i) {
        var b = document.createElement('button');
        var nom = vue.querySelector('.bvj__nom');
        b.type = 'button';
        b.className = 'bvj__point';
        b.setAttribute('aria-label', nom && nom.textContent.trim() ? nom.textContent.trim() : 'Article ' + (i + 1));
        b.addEventListener('click', function () {
          rendu = true;
          arreter();
          montrer(i);
        });
        points.appendChild(b);
        return b;
      });

      scene.parentNode.insertBefore(points, scene.nextSibling);

      function montrer(i) {
        index = (i + vues.length) % vues.length;
        vues.forEach(function (v, n) {
          if (n === index) {
            v.setAttribute('data-bvj-actif', '');
            v.removeAttribute('tabindex');
          } else {
            v.removeAttribute('data-bvj-actif');
            v.setAttribute('tabindex', '-1');
          }
        });
        boutons.forEach(function (b, n) {
          b.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
      }

      function battement() {
        if (rendu || survol || !aLEcran(bloc)) return;
        montrer(index + 1);
      }

      function demarrer() {
        arreter();
        if (!rendu && !REDUIT && delai) minuteur = window.setInterval(battement, delai);
      }

      function arreter() {
        if (minuteur) {
          window.clearInterval(minuteur);
          minuteur = null;
        }
      }

      /* Le survol suspend sans arreter : une carte cliquable qui s'echappe
         pendant qu'on vise le titre est agacante. Le focus clavier compte
         comme un survol, sinon la tabulation perdrait sa cible. */
      bloc.addEventListener('mouseenter', function () { survol = true; });
      bloc.addEventListener('mouseleave', function () { survol = false; });
      bloc.addEventListener('focusin', function () { survol = true; });
      bloc.addEventListener('focusout', function () { survol = false; });

      montrer(0);
      demarrer();
    }

    function tout() {
      document.querySelectorAll('[data-bvj]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }

    /* Dans l'editeur, une section rechargee perd son initialisation et ses
       puces, recreees avec le nouveau balisage. */
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-bvj]').forEach(function (b) {
        b.dataset.bvjPret = '';
        var p = b.querySelector('.bvj__points');
        if (p) p.remove();
      });
      tout();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
